import { combineReducers } from "redux";
import { serviceTruckState } from "./serviceTruckReducer";

export const serviceTruckReducer = combineReducers({
  serviceTruckState: serviceTruckState
});


